{
  "<0>If your request is taking longer than expected, please contact <2>Weave Support</2>.</0>": "<0>If your request is taking longer than expected, please contact <2>Weave Support</2>.</0>",
  "Address 1 *": "Address 1 *",
  "Address 2": "Address 2",
  "An error occurred while fetching integrations": "An error occurred while fetching integrations",
  "An error occurred while loading {{pmsNameAcronym}}s.": "An error occurred while loading {{pmsNameAcronym}}s.",
  "An error occurred while loading {{pmsName}} information": "An error occurred while loading {{pmsName}} information",
  "An error occurred while loading {{pmsName}} status": "An error occurred while loading {{pmsName}} status",
  "Back": "Back",
  "City *": "City *",
  "Close": "Close",
  "Continue integrating your Practice Management System (PMS) by downloading the Sync App Installer below.": "Continue integrating your Practice Management System (PMS) by downloading the Sync App Installer below.",
  "Country *": "Country *",
  "Done": "Done",
  "Done for Now": "Done for Now",
  "Download": "Download",
  "Download Sync App Installer for {{operatingSystem}}": "Download Sync App Installer for {{operatingSystem}}",
  "Download cancelled": "Download cancelled",
  "Enroll": "Enroll",
  "Exit Task": "Exit Task",
  "Failed to download sync app installer": "Failed to download sync app installer",
  "Fields marked as * are required": "Fields marked as * are required",
  "Follow the steps below to enroll your practice to Cornerstone": "Follow the steps below to enroll your practice to Cornerstone",
  "Follow the steps below to sync to your Weave account": "Follow the steps below to sync to your Weave account",
  "Invalid phone number": "Invalid phone number",
  "Let's get your data syncing to Weave": "Let's get your data syncing to Weave",
  "Next": "Next",
  "Postal Code *": "Postal Code *",
  "Practice Management Software": "Practice Management Software",
  "Practice Name *": "Practice Name *",
  "Requests take about couple of hours to complete. We'll notify you when your data has successfully synced.": "Requests take about couple of hours to complete. We'll notify you when your data has successfully synced.",
  "Select {{pmsNameAcronym}}": "Select {{pmsNameAcronym}}",
  "Setup In-Progress": "Setup In-Progress",
  "Setup in progress": "Setup in progress",
  "Something went wrong. Please try again later.": "Something went wrong. Please try again later.",
  "State *": "State *",
  "Step": "Step",
  "Submit Sync Request": "Submit Sync Request",
  "Success!": "Success!",
  "Sync In Progress": "Sync In Progress",
  "Sync app installer downloaded successfully": "Sync app installer downloaded successfully",
  "Synced with Weave": "Synced with Weave",
  "Syncing has begun...": "Syncing has begun...",
  "Technical Contact Email *": "Technical Contact Email *",
  "Technical Contact First Name *": "Technical Contact First Name *",
  "Technical Contact Job Title *": "Technical Contact Job Title *",
  "Technical Contact Last Name *": "Technical Contact Last Name *",
  "Technical Contact Phone *": "Technical Contact Phone *",
  "To add your new Practice Management System (PMS) integration, please contact your onboarder or support for assistance.": "To add your new Practice Management System (PMS) integration, please contact your onboarder or support for assistance.",
  "Try Again": "Try Again",
  "Unknown error occured. Please try again or contact support": "Unknown error occured. Please try again or contact support",
  "Waiting for Sync Confirmation from your PMS.": "Waiting for Sync Confirmation from your PMS.",
  "What is your {{pmsNameAcronym}}?": "What is your {{pmsNameAcronym}}?",
  "{{pmsName}} Data Sync": "{{pmsName}} Data Sync"
}
